import React, { useState } from "react";
import "./AddExpense.css";
import dropdownPng from "../../images/down-arrow.png";
import educationPng from "../../images/education.png";
import healthcarePng from "../../images/healthcare.png";
import shoppingPng from "../../images/shopping-cart.png";
import foodPng from "../../images/food.png";
import othersPng from "../../images/other.png";
import { useDispatch } from "react-redux";
import { rxDB } from "../../redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddExpense = () => {
  const dispatch = useDispatch();

  const [title, setTitle] = useState("");
  const [amount, setAmount] = useState("");
  const [category, setCategory] = useState("");
  const [categoryOpen, setCategoryOpen] = useState(false);
  const [categoryColor, setCategoryColor] = useState("");

  const categories = [
    {
      id: 1,
      title: "Education",
      icon: educationPng,
      color: "#7209b7",
    },
    {
      id: 2,
      title: "Healthcare",
      icon: healthcarePng,
      color: "#f72585",
    },
    {
      id: 3,
      title: "Shopping",
      icon: shoppingPng,
      color: "#3a0ca3",
    },
    {
      id: 4,
      title: "Food",
      icon: foodPng,
      color: "#4361ee",
    },
    {
      id: 5,
      title: "Other",
      icon: othersPng,
      color: "#4cc9f0",
    },
  ];

  const titleHandler = (e) => {
    setTitle(e.target.value);
  };

  const amountHandler = (e) => {
    const amountval = parseFloat(e.target.value);
    if (amountval <= 0) {
      setAmount("");
      return;
    } else {
      setAmount(e.target.value);
    }
  };

  const categoryHandler = (e, clr) => {
    setCategory(e);
    setCategoryColor(clr);
    setCategoryOpen(!categoryOpen);
  };

  const categoryPopupHandler = () => {
    setCategoryOpen(!categoryOpen);
  };

  const SubmitExpenseHandler = () => {
    const notify = () => toast.success("new expense added");
    notify();

    const objDate = new Date().toLocaleString();

    const strDD = JSON.stringify(objDate);

    const newExpenseItem = {
      title,
      amount,
      category,
      categoryColor,
      createdAt: strDD,
      id: amount + Math.random(),
    };

    dispatch(rxDB.addExpense(newExpenseItem));

    setTitle("");
    setAmount("");
    setCategory("");
  };

  return (
    <div className="add__ExpenseContainer">
      <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
      />
      <div className="addExpense__Box">
        <div className="add__title">
          <label className="add__titleLabel">Title</label>
          <input
            type="text"
            value={title}
            placeholder="enter expense title"
            onChange={(e) => titleHandler(e)}
          />
        </div>

        <div className="add__Amount">
          <label className="add__titleLabel">Amount</label>
          <input
            type="number"
            placeholder="expense amount"
            value={amount}
            onChange={(e) => amountHandler(e)}
          />
        </div>

        <div className="add__CategoryBox">
          <div className="category__Items">
            <lebel className="box__AX">Category</lebel>
            <div
              className="category__dropDownBox"
              onClick={categoryPopupHandler}
            >
              <input
                value={category}
                type="none"
                placeholder="select category"
              />
              <img
                className="category__ImageDropDwn"
                src={dropdownPng}
                alt="dropdown"
              />
            </div>
          </div>
          {categoryOpen && (
            <div className="category__PopupContainer">
              {categories.map((catgry) => (
                <div
                  className="category__Popup__Item"
                  style={{
                    borderRight: `8px solid ${catgry.color}`,
                  }}
                  key={catgry.id}
                  onClick={(e) => categoryHandler(catgry.title, catgry.color)}
                >
                  <label>{catgry.title}</label>
                  <img
                    src={catgry.icon}
                    alt={catgry.title}
                    className="category__popup__Img"
                  />
                </div>
              ))}
            </div>
          )}
          {title && amount && category && (
            <div onClick={SubmitExpenseHandler} className="addNewExpenseBtn">
              Add
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddExpense;
